import React, {createRef} from "react";
import PropTypes from "prop-types";
import BaseComponent from "../../../../lib/components/BaseComponent";
import InputFieldGenerator from "../entity/fields/InputFieldGenerator";
import DataType from "../../../../lib/model/types/DataType";
import shortid from "shortid";
import CampaignService from "../../../model/service/campaign/CampaignService";
import {Alert, Stack} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";

class VariablesContent extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      fieldValues: {} // Store the values of input fields
    };
    this.inputFieldGenerator = new InputFieldGenerator((e, id, value) => this.handleInputChange(e, id, value));
    this.fieldRefs = [];
  }

  handleInputChange(e, variableName, value) {
    let fieldValue;
    if (typeof value === 'object' && value.hasOwnProperty('currentTarget')) {
      fieldValue = value.currentTarget.value;
    } else {
      fieldValue = value;
    }
    if (this.props.onVariablesChange) {
      this.props.onVariablesChange(this.props.variableGroup, variableName, fieldValue);
    }
  };

  createFields() {
    let fields = [];
    for (let variableKey in this.props.variableGroup.variable) {
      let variable = this.props.variableGroup.variable[variableKey];
      let variableValue = null;
      if (this.props.variableValues !== undefined) {
        variableValue = this.props.variableValues[variable.name];
      }
      let field = this.createField(variable, variableKey, variableValue);
      if (field !== null) {
        this.state.fieldValues[variable.name] = variableValue.value;
        fields.push(field);
      }
    }
    return fields;
  }

  createField(variable, variableKey, variableValue) {
    let fieldRef = createRef();
    if (variableValue !== undefined) {
      let value = this.initDefaultFieldValue(variableValue);
      let field;
      let dtoProperties = CampaignService.createCampaignRedirectProperty(this.props.campaignId);
      if (variable.type.type === DataType.STRING && variable.type.isHtml) {
        field = <div className='col-span-full' key={shortid()}>
          {this.inputFieldGenerator.initField(variable.type, variable.name, value, variable.description, fieldRef,
            dtoProperties, (this.getBlockingField() ? 0 : 65535))}
        </div>;
      } else {
        field = this.inputFieldGenerator.initField(variable.type, variable.name, value, variable.description, fieldRef,
          dtoProperties, (this.getBlockingField() ? 0 : 65535));
      }
      this.fieldRefs.push(fieldRef);
      return field;
    }
    return null;
  }

  createBlockingField() {
    let self = this;
    return <Stack className='col-span-full' sx={{width: '100%'}} spacing={2}>
      <Alert severity="error" sx={{
        backgroundColor: '#e06161', color: '#600', '& .MuiAlert-icon': {
          color: '#600', 'font-size': '40px'
        }, 'font-size': '28px'
      }}>
        <Stack>
          <div>Achtung: Es gibt ein geplanter Versand, welcher auf diese Variablen zugreift.</div>
          <div className='text-base'><Button sx={{backgroundColor: '#600'}} variant="contained" onClick={() => {
            self.props.myVariablesForm.setBlockingField(this.props.variableGroup.name, false);
            this.setState(this.state);
          }}>Wenn Sie trotzdem eine Anpassung vornehmen
             wollen, können Sie dies hier
             bestätigen.</Button></div>
        </Stack>
      </Alert>
    </Stack>;
  }

  getBlockingField() {
    if (this.props.myVariablesForm && this.props.myVariablesForm.getBlockingField) {
      return this.props.myVariablesForm.getBlockingField(this.props.variableGroup.name);
    } else {
      toast.error('System-Fehler, Parent-Objekt fehlt!');
      return false;
    }
  }

  initDefaultFieldValue(variableValue) {
    let variableNew;
    switch (variableValue.variableDef.type.type) {
      case DataType.BOOLEAN:
        variableNew = variableValue.value === "1" || variableValue.value === "true" || variableValue.value === "ja" ||
          variableValue.value === "JA" || variableValue.value === 1 || variableValue.value === true;
        break;
      case DataType.INTEGER:
        variableNew = parseInt(variableValue.value);
        break;
      default:
        variableNew = variableValue.value;
        break;
    }
    return variableNew;
  }

  render() {
    let fields = this.createFields();
    return (<div className={'grid grid-cols-1 lg:grid-cols-2 gap-4 pt-3 ' + this.props.className}>
      {this.getBlockingField() && this.createBlockingField()}
      {fields}
    </div>);
  }
}

VariablesContent.propTypes = {
  className: PropTypes.string,
  variableGroup: PropTypes.any,
  variableValues: PropTypes.any,
  onVariablesChange: PropTypes.func,
  campaignId: PropTypes.any,
  myVariablesForm: PropTypes.any
};

export default VariablesContent;
